<template>
  <div>
    <el-dialog :title="`模板“${name}”——添加使用员工`" :visible.sync="visible" width="510px" custom-class="my-dialog-template" :close-on-click-modal="false">
      <el-form :inline="true" :model="formData" ref="formRef" class="my-form-template" label-width="120px" v-loading="loading">
        <el-form-item label="选择员工" prop="userIds" class="full" :rules="$tools.formRule.arrRequired('请选择使用员工')">
          <el-checkbox v-model="isAll" @change="selectAll">全部员工</el-checkbox>
          <el-select v-model="formData.userIds" placeholder="请选择" multiple collapse-tags @change="selectChange">
            <el-option v-for="(bean, i) in userList" :key="i" :label="bean.shortName || bean.name" :value="bean.id"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div class="dialog-footer">
        <el-button type="warning" plain @click="visible = false">取消</el-button>
        <el-button type="warning" class="bgBtn" @click="save()">保存</el-button>
      </div>
    </el-dialog>
    <modalLoading ref="modalLoading" class="modal-loading"></modalLoading>
  </div>
</template>
<script>
import modalLoading from "@/components/modalLoading";
export default {
  data: () => ({
    visible: false,
    loading: false,
    isAll: false,
    name: "",
    type: '',
    mechanId: '',
    formData: {
      userIds: []
    },
    userList: [],
  }),
  components: { modalLoading },
  methods: {
    open(data = {}) {
      console.log(data)
      this.mechanId = data.mechanId;
      this.name = data.name;
      this.formData = {
        productTemplateCode: data.productTemplateCode,
        userIds: []
      }
      this.visible = true;
      this.isAll = false;
      this.$refs.formRef && this.$refs.formRef.clearValidate()
      this.getUserList();

    },
    selectChange() {
      if (this.userList.length == this.formData.userIds.length) {
        this.isAll = true;
      } else {
        this.isAll = false;
      }
    },
    // 选择所有团队
    selectAll() {
      if (this.isAll) {
        const list = this.userList.map((item) => {
          return item.id;
        })
        this.$set(this.formData, "userIds", list);
      } else {
        this.$set(this.formData, "userIds", []);
      }
    },
    getUserList() {
      this.$http({
        url: '/master/subAccount/queryUsersList',
        type: 'PUT',
        params: {
          mechanId: this.mechanId,
          filterProductTemplateCode: this.formData.productTemplateCode,
        },
      }).then(res => {
        this.userList = res.data
      })
    },
    save() {
      this.$refs['formRef'].validate((valid) => {
        if (valid) {
          this.$refs.modalLoading.open({
            title: "操作中，请稍等...",
          })
          this.$http({
            url: "/master/productTemplate/batchAllot",
            type: 'PUT',
            params: this.formData,
          }).then(res => {
            this.$refs.modalLoading.setText({
              title: "完成！",
              progress: 100
            })
            this.$emit("reload");
            this.visible = false;
          })
        }
      })
    },
  },
}
</script>
<style lang='scss' scoped>
</style>